
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartTooltip } from "./ChartTooltip";

interface BarDataPoint {
  name: string;
  value: number;
  value2?: number;
}

interface BarChartCardProps {
  title: string;
  data: BarDataPoint[];
  color?: string;
  color2?: string;
  label1?: string;
  label2?: string;
}

export function BarChartCard({
  title, data, color = "#c9a84c", color2 = "#7c9a5e", label1 = "Hodnota", label2,
}: BarChartCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[200px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
              <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#a89f93" }} stroke="#2e2e2e" />
              <YAxis tick={{ fontSize: 11, fill: "#a89f93" }} stroke="#2e2e2e" />
              <Tooltip content={<ChartTooltip isDate={false} />} />
              {label2 && <Legend />}
              <Bar dataKey="value" name={label1} fill={color} radius={[4, 4, 0, 0]} />
              {label2 && <Bar dataKey="value2" name={label2} fill={color2} radius={[4, 4, 0, 0]} />}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
